import { render, staticRenderFns } from "./ResourceBookingCategoryList.vue?vue&type=template&id=16c0474f"
import script from "./ResourceBookingCategoryList.vue?vue&type=script&lang=js"
export * from "./ResourceBookingCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports